import request from '@/shared/api/request';

export const deleteFirewall = (uuid: string): Promise<void> =>
  request({
    url: `/firewalls/${uuid}/`,
    method: 'DELETE',
  });
